import { supabase } from './supabase';

export const testSupabaseConnection = async () => {
  try {
    // Try to get the server timestamp
    const { data, error } = await supabase
      .from('profiles')
      .select('*', { count: 'exact' });

    if (error) {
      // Always log connection errors as they affect functionality
      console.error('Supabase connection test failed:', error.message);
      return false;
    }

    console.log('Supabase', 'Connection test successful!');
    return true;
  } catch (error) {
    // Always log connection errors as they affect functionality
    console.error('Error testing Supabase connection:', error);
    return false;
  }
}; 